import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'

const initialState = {
  isClaimsDrawerOpen: false,
  isExpensesTable: false,
  selectedClaimRow: null,
  isNewClaimMode: false,
  isSubmissionVersion: false,
  editMode: false,
  draftClaims: [],
  initialDrawerTab: null,
  openDirectToForm: false
}

export const useClaimsStore = storeWrapper('useClaimsStore', (set) => ({
  ...initialState,
  setIsClaimsDrawerOpen: (
    isExpensesTable = false,
    rowData = null,
    isSubmissionVersion = false,
    initialDrawerTab = null
  ) => {
    set((state) => ({
      isClaimsDrawerOpen: !state.isClaimsDrawerOpen,
      isExpensesTable: isExpensesTable,
      selectedClaimRow: state.isClaimsDrawerOpen ? null : rowData,
      isNewClaimMode: false,
      isSubmissionVersion: state.isClaimsDrawerOpen ? false : isSubmissionVersion,
      editMode: state.isClaimsDrawerOpen ? false : rowData !== null,
      initialDrawerTab: state.isClaimsDrawerOpen ? null : initialDrawerTab
    }))
  },
  openNewClaimDrawer: (isExpensesTable = true, openDirectToForm = false) => {
    set({
      isClaimsDrawerOpen: true,
      isExpensesTable: isExpensesTable,
      selectedClaimRow: null,
      isNewClaimMode: true,
      openDirectToForm
    })
  },
  closeClaimsDrawer: () => {
    set({
      isClaimsDrawerOpen: false,
      selectedClaimRow: null,
      isNewClaimMode: false,
      isSubmissionVersion: false,
      editMode: false,
      initialDrawerTab: null,
      openDirectToForm: false
    })
  },
  createUpdateExpenseUserPermission: async ({ payload }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: 'createUpdateExpenseUserPermission',
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              method: 'POST',
              service: 'accounts',
              endpoint: '/ExpenseUserPermission/CreateUpdate',
              data: payload
            })

            resolve(response)
          } catch (error) {
            console.error('Error creating/updating expense user permission:', error)
            reject(error)
          }
        }
      })
    })
  },
  fetchAllExpenseUserPermissions: async () => {
    return new Promise((resolve, reject) => {
      debounce({
        id: 'fetchAllExpenseUserPermissions',
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              service: 'accounts',
              endpoint: '/ExpenseUserPermission/GetAll'
            })
            const permissions = Array.isArray(response) ? response : []
            resolve(permissions)
          } catch (error) {
            console.error('Error fetching permissions:', error)
            reject(error)
          }
        }
      })
    })
  },
  fetchAllExpenseUserPermissionsByProcessorUserId: async ({ processorUserId }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: `fetchAllExpenseUserPermissionsByProcessorUserId-${processorUserId}`,
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              service: 'accounts',
              method: 'GET',
              endpoint: `/ExpenseUserPermission/GetAllByProcessorUserId`,
              data: {
                processorUserId: processorUserId
              }
            })

            const permissions = Array.isArray(response) ? response : []
            resolve(permissions)
          } catch (error) {
            console.error('Error fetching permissions by processor user ID:', error)
            reject(error)
          }
        }
      })
    })
  },
  createUpdateOvertimeUserPermission: async ({ payload }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: 'createUpdateOvertimeUserPermission',
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              method: 'POST',
              service: 'accounts',
              endpoint: '/OvertimeUserPermission/CreateUpdate',
              data: payload
            })

            resolve(response)
          } catch (error) {
            console.error('Error creating/updating overtime user permission:', error)
            reject(error)
          }
        }
      })
    })
  },
  fetchAllOvertimeUserPermissions: async () => {
    return new Promise((resolve, reject) => {
      debounce({
        id: 'fetchAllOvertimeUserPermissions',
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              service: 'accounts',
              endpoint: '/OvertimeUserPermission/GetAll'
            })
            const permissions = Array.isArray(response) ? response : []
            resolve(permissions)
          } catch (error) {
            console.error('Error fetching overtime permissions:', error)
            reject(error)
          }
        }
      })
    })
  },
  fetchAllOvertimeUserPermissionsByProcessorUserId: async ({ processorUserId }) => {
    return new Promise((resolve, reject) => {
      debounce({
        id: `fetchAllOvertimeUserPermissionsByProcessorUserId-${processorUserId}`,
        delay: 600,
        callback: async () => {
          try {
            const response = await ospreyAPI({
              service: 'accounts',
              method: 'GET',
              endpoint: `/OvertimeUserPermission/GetAllByProcessorUserId`,
              data: {
                processorUserId: processorUserId
              }
            })

            const permissions = Array.isArray(response) ? response : []
            resolve(permissions)
          } catch (error) {
            console.error('Error fetching overtime permissions by processor user ID:', error)
            reject(error)
          }
        }
      })
    })
  },
  reset: () => set(initialState)
}))
